/* "Cherry" by tPenguinLTG
 * https://www.deviantart.com/tpenguinltg/art/Cherry-747961418
 */

export default {
  name: 'cherry',
  anchor: 'rgb(128, 0, 1)',
  anchorVisited: 'rgb(128, 0, 1)',
  borderDark: 'rgb(128, 128, 128)',
  borderDarkest: 'rgb(64, 64, 64)',
  borderLight: 'rgb(200, 212, 208)',
  borderLightest: 'rgb(255, 255, 255)',
  canvas: 'rgb(255, 255, 255)',
  canvasText: 'rgb(0, 0, 0)',
  canvasTextDisabled: 'rgb(128, 128, 128)',
  canvasTextDisabledShadow: 'rgb(255, 255, 255)',
  canvasTextInvert: 'rgb(255, 255, 255)',
  checkmark: 'rgb(0, 0, 0)',
  checkmarkDisabled: 'rgb(128, 128, 128)',
  flatDark: 'rgb(128, 128, 128)',
  flatLight: 'rgb(200, 212, 208)',
  focusSecondary: 'rgb(255, 255, 255)',
  headerBackground: 'rgb(106, 10, 36)',
  headerNotActiveBackground: 'rgb(128, 128, 128)',
  headerNotActiveText: 'rgb(212, 208, 200)',
  headerText: 'rgb(255, 255, 255)',
  hoverBackground: 'rgb(106, 10, 36)',
  material: 'rgb(200, 212, 208)',
  materialDark: 'rgb(128, 128, 128)',
  materialText: 'rgb(0, 0, 0)',
  materialTextDisabled: 'rgb(128, 128, 128)',
  materialTextDisabledShadow: 'rgb(255, 255, 255)',
  materialTextInvert: 'rgb(255, 255, 255)',
  progress: 'rgb(106, 10, 36)',
  tooltip: 'rgb(225, 254, 255)',
};
